<template>
  <div>
    <div class="page-title-cont">
      <h1 class="wp-heading-inline">WPCal.io - {{ page_title }}</h1>
      <AdminHeaderRight />
    </div>
    <div
      :class="{
        'create-event-type': view == 'add',
        'edit-event-type': view == 'edit'
      }"
    >
      <div
        class="steps-main"
        :class="{ 'step-last': view == 'add' && tabs_flow.steps[2].form }"
      >
        <div v-if="view == 'add'">
          <div class="validation_errors_cont"></div>
          <ServiceFormStep1
            :$v="$v"
            :step="tabs_flow.steps[0]"
            :view="view"
            :form="form"
            @validate-may-navigate-or-submit="
              validate_may_navigate_or_submit($event)
            "
            @set-active-step-and-toggle="set_active_step_and_toggle"
          ></ServiceFormStep1>
          <ServiceFormStep2
            :$v="$v"
            :step="tabs_flow.steps[1]"
            :view="view"
            :form="form"
            :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
            @validate-may-navigate-or-submit="
              validate_may_navigate_or_submit($event)
            "
            @set-active-step-and-toggle="set_active_step_and_toggle"
          ></ServiceFormStep2>
          <ServiceFormStep3
            :$v="$v"
            :step="tabs_flow.steps[2]"
            :view="view"
            :form="form"
            :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
            @validate-may-navigate-or-submit="
              validate_may_navigate_or_submit($event)
            "
          ></ServiceFormStep3>
        </div>

        <div v-if="view == 'edit'">
          <div class="validation_errors_cont"></div>
        </div>
        <ServiceFormEditView
          v-if="view == 'edit'"
          :$v="$v"
          :view="view"
          :service_id="service_id"
          :form="form"
          :saved_form="saved_form"
          :edit_view="edit_view"
          :create_or_update_btn_is_enabled="create_or_update_btn_is_enabled"
          @submit-form="validate_may_navigate_or_submit($event)"
          @save-questions="form_submit()"
          @edit-view-toggle-steps="edit_view_toggle_steps($event)"
          @change-service-status="
            may_show_service_status_change_dialog($event, {
              id: service_id,
              name: saved_form.name
            })
          "
        />
      </div>
    </div>
    <!-- <v-dialog /> -->
    <AdminInfoLine
      v-if="view == 'edit'"
      :timezone="saved_form.timezone"
      :info_slugs="
        view == 'edit'
          ? [
              'booking_default_reminder_email',
              'timings_in_timezone',
              'conflict_resolution_for_host'
            ]
          : []
      "
    />
  </div>
</template>

<script>
import ServiceFormStep1 from "@/components/admin/ServiceFormStep1.vue";
import ServiceFormStep2 from "@/components/admin/ServiceFormStep2.vue";
import ServiceFormStep3 from "@/components/admin/ServiceFormStep3.vue";

import ServiceFormEditView from "@/components/admin/ServiceFormEditView.vue";

import {
  required,
  requiredIf,
  between,
  minLength,
  //minValue,
  // maxValue,
  integer
} from "vuelidate/lib/validators";

import {
  valid_date,
  min_date_as,
  valid_time,
  min_time_as,
  check_periods_collide,
  subset,
  must_be_1_or_0,
  in_array
} from "@/utils/common_func.js";

import { on_before_leave_alert_if_unsaved } from "@/utils/on_before_leave_alert_if_unsaved_mixin.js";
import { admin_service_status_toggle_mixin } from "@/utils/admin_service_status_toggle_mixin.js";

import axios from "axios";

import { isEqual as _isEqual } from "lodash-es";

export default {
  name: "ServiceForm",
  mixins: [
    on_before_leave_alert_if_unsaved("saved_form", "form"),
    admin_service_status_toggle_mixin
  ],
  props: {
    msg: String
  },
  components: {
    ServiceFormStep1,
    ServiceFormStep2,
    ServiceFormStep3,
    ServiceFormEditView
  },
  data() {
    return {
      view: "",
      service_id: null,
      form: {
        name: "",
        status: "",
        locations: [],
        descr: "",
        post_id: "",
        color: "",
        relationship_type: "",
        timezone: "",
        duration: "30",
        display_start_time_every: "15",
        max_booking_per_day: "",
        min_schedule_notice: {
          type: "units",
          time_units: "4",
          time_units_in: "hrs",
          days_before_time: "00:00:00",
          days_before: 0
        },
        event_buffer_before: 0,
        event_buffer_after: 0,
        is_manage_private: "0",
        invitee_notify_by: "calendar_invitation",
        service_admin_user_ids: [
          this.$store.getters.get_current_admin_details.id
        ],
        invitee_questions: {
          questions: []
        },
        default_availability_details: {
          date_range_type: "relative",
          from_date: "",
          to_date: "",
          date_misc: "+60D",
          periods: [],
          day_index_list: []
        },
        post_details: {
          status: "",
          link: ""
        }
      },
      saved_form: this.clone_deep(this.form), //to avoid console error on initial rendering.
      tabs_flow: {
        active_step_id: 1,
        steps: [
          {
            id: 1,
            form: true,
            summary: false,
            upcoming: false
          },
          {
            id: 2,
            form: false,
            summary: false,
            upcoming: true
          },
          {
            id: 3,
            form: false,
            summary: false,
            upcoming: true
          }
        ]
      },
      edit_view: {
        active_step_id: null,
        step2: {
          //Event type details
          id: 2,
          summary: true,
          form: false
        },
        step3: {
          //Event type duration &amp; timings
          id: 3,
          summary: true,
          form: false
        },
        step5: {
          //Event type communication
          id: 5,
          summary: true,
          form: false
        }
      },
      create_or_update_btn_is_enabled: true,
      skip_leaving_warining: false,
      service_name_last_saved: ""
    };
  },
  validations: {
    form: {
      name: { required },
      // locations: "",
      // descr: "",
      // post_id: "",
      color: { required },
      relationship_type: { required },
      timezone: { required },
      duration: {
        required,
        integer,
        between_duration: between(1, 1440)
      },
      display_start_time_every: {
        required,
        integer,
        between_display_start_time_every: between(1, 1440)
      },
      max_booking_per_day: {
        integer,
        between_max_booking_per_day: between(1, 1440)
      },
      min_schedule_notice: {
        //type: "units",
        time_units: {
          integer,
          required: requiredIf(function() {
            return this.form.min_schedule_notice.type === "units";
          })
        },
        //time_units_in: "hrs",
        days_before_time: {
          valid_time,
          required: requiredIf(function() {
            return this.form.min_schedule_notice.type === "time_days_before";
          })
        }
        //days_before: 1
      },
      event_buffer_before: {
        integer,
        between_event_buffer_before: between(0, 300)
      },
      event_buffer_after: {
        integer,
        between_event_buffer_before: between(0, 300)
      },
      is_manage_private: {
        required,
        must_be_1_or_0
      },
      invitee_notify_by: {
        required,
        invitee_notify_by_in_array: in_array(["calendar_invitation", "email"])
      },
      service_admin_user_ids: {
        required,
        minLength: minLength(1)
      },
      // invitee_questions: {
      //   questions: []
      // },
      default_availability_details: {
        date_range_type: {
          required,
          date_range_type_in_array: in_array([
            "relative",
            "from_to",
            "infinite"
          ])
        },
        date_misc: {
          required: requiredIf(function() {
            return (
              this.form.default_availability_details.date_range_type ===
              "relative"
            );
          })
        },
        from_date: {
          required: requiredIf(function() {
            return (
              this.form.default_availability_details.date_range_type ===
              "from_to"
            );
          }),
          valid_date
        },
        to_date: {
          required: requiredIf(function() {
            return (
              this.form.default_availability_details.date_range_type ===
              "from_to"
            );
          }),
          valid_date,
          min_date: min_date_as("from_date")
        },
        // : "",
        // date_misc: "+60D",
        periods: {
          required,
          minLength: minLength(1),
          check_periods_collide,
          $each: {
            from_time: { required, valid_time },
            to_time: {
              required,
              valid_time,
              min_time: min_time_as("from_time")
            }
          }
        },
        day_index_list: {
          required,
          subset_working_days: subset([1, 2, 3, 4, 5, 6, 7])
        }
      }
    },
    step1: ["form.relationship_type"],
    step2: [
      "form.name",
      "form.color",
      "form.is_manage_private",
      "form.service_admin_user_ids"
    ],
    step3: [
      "form.duration",
      "form.display_start_time_every",
      "form.timezone",
      "form.max_booking_per_day",
      "form.min_schedule_notice.time_units",
      "form.min_schedule_notice.days_before_time",
      "form.event_buffer_before",
      "form.event_buffer_after",
      "form.default_availability_details.date_range_type",
      "form.default_availability_details.date_misc",
      "form.default_availability_details.from_date",
      "form.default_availability_details.to_date",
      "form.default_availability_details.periods",
      "form.default_availability_details.day_index_list"
    ],
    step5: ["form.invitee_notify_by"],
    step3_advance_options: [
      "form.max_booking_per_day",
      "form.min_schedule_notice.time_units",
      "form.min_schedule_notice.days_before_time",
      "form.event_buffer_before",
      "form.event_buffer_after"
    ]
  },
  computed: {
    page_title() {
      let title = this.T__("Create New Event Type");
      if (this.$route.name == "service_edit") {
        title = this.T__("Event Type - ") + this.saved_form.name;
      }
      return title;
    },
    document_title() {
      let title = this.T__("Create New Event Type");
      if (this.$route.name == "service_edit") {
        title = "";
        if (this.saved_form?.name) {
          title = this.saved_form.name + " ‹ ";
        }
        title += this.T__("Event Type");
      }
      return title;
    }
  },
  methods: {
    set_active_step(step_id) {
      this.tabs_flow.active_step_id = step_id;
    },
    toggle_steps() {
      for (let i in this.tabs_flow.steps) {
        if (this.tabs_flow.active_step_id == this.tabs_flow.steps[i].id) {
          this.tabs_flow.steps[i].form = true;
          this.tabs_flow.steps[i].summary = false;
          this.tabs_flow.steps[i].upcoming = false;
        } else if (this.tabs_flow.active_step_id < this.tabs_flow.steps[i].id) {
          this.tabs_flow.steps[i].form = false;
          this.tabs_flow.steps[i].summary = false;
          this.tabs_flow.steps[i].upcoming = true;
        } else if (this.tabs_flow.active_step_id > this.tabs_flow.steps[i].id) {
          this.tabs_flow.steps[i].form = false;
          this.tabs_flow.steps[i].summary = true;
          this.tabs_flow.steps[i].upcoming = false;
        }
      }
    },
    edit_view_toggle_steps(step) {
      if (!step.form) {
        //currently close, check any other form is open, if so try to close -accordian style(one open at a time)
        let other_step_id =
          step.id != this.edit_view.active_step_id
            ? this.edit_view.active_step_id
            : null;
        if (other_step_id && this.edit_view["step" + other_step_id].form) {
          if (this.oblaiu_is_form_dirty()) {
            if (this.oblaiu_confirm_leave(true)) {
              this.form = this.clone_deep(this.saved_form);
            } else {
              return;
            }
          }
          this.edit_view["step" + other_step_id].form = false;
          this.edit_view["step" + other_step_id].summary = true;
          this.$v["step" + other_step_id].$reset();
          this.edit_view.active_step_id =
            other_step_id == this.edit_view.active_step_id
              ? null
              : this.edit_view.active_step_id;
        }
      } else {
        if (this.oblaiu_is_form_dirty()) {
          this.form = this.clone_deep(this.saved_form);
        }
      }
      step.summary = !step.summary;
      step.form = !step.form;
      this.$v["step" + step.id].$reset();

      if (step.form) {
        //form opened
        this.edit_view.active_step_id = step.id;
        this.scroll_to_if_not_in_view_port("#service_form_step" + step.id);
      } else {
        this.edit_view.active_step_id = null;
      }
    },
    set_active_step_and_toggle(step_id) {
      this.set_active_step(step_id);
      this.toggle_steps();
    },
    edit_view_form_submit() {
      this.form_submit();
    },
    edit_view_reset() {
      this.edit_view.step2.summary = true;
      this.edit_view.step2.form = false;
      this.edit_view.step3.summary = true;
      this.edit_view.step3.form = false;
      this.edit_view.step5.summary = true;
      this.edit_view.step5.form = false;
      this.edit_view.active_step_id = null;
    },
    validate_may_navigate_or_submit(step_id) {
      if (this.view == "add") {
        if (step_id == 1 || step_id == 2 || step_id == 3) {
          this.$v["step" + step_id].$touch(); //trigger validation

          if (step_id == 3) {
            if (this.$v.step3_advance_options.$anyError) {
              this.$root.$emit("show-advance-options");
            }
          }

          if (!this.$v["step" + step_id].$anyError) {
            if (step_id == 1 || step_id == 2) {
              let next_step_id = step_id + 1;
              this.set_active_step_and_toggle(next_step_id);
            } else if (step_id == 3) {
              this.form_submit();
            }
          } else {
            this.scroll_to_first_validation_error();
          }
        }
      } else if (this.view == "edit") {
        if (step_id == 2 || step_id == 3 || step_id == 5) {
          this.$v["step" + step_id].$touch(); //trigger validation

          if (step_id == 3) {
            if (this.$v.step3_advance_options.$anyError) {
              this.$root.$emit("show-advance-options");
            }
          }

          if (!this.$v["step" + step_id].$anyError) {
            this.edit_view_form_submit();
          } else {
            this.scroll_to_first_validation_error();
          }
        }
      }
    },
    load_page() {
      if (this.$route.name == "service_add") {
        this.load_add_page();
      } else if (this.$route.name == "service_edit") {
        this.load_edit_page();
      }
    },
    async load_add_page() {
      Object.assign(this.$data, this.$options.data.apply(this)); //re-initilize data in Vue
      this.view = "add";

      let general_setting = this.$store.getters.get_general_settings;

      if (general_setting.hasOwnProperty("working_hours")) {
        this.form.default_availability_details.periods.push(
          general_setting.working_hours
        );
      }
      if (general_setting.hasOwnProperty("working_days")) {
        this.form.default_availability_details.day_index_list = this.clone_deep(
          general_setting.working_days
        );
      }

      if (general_setting.hasOwnProperty("timezone")) {
        this.form.timezone = this.clone_deep(general_setting.timezone);
      }

      this.saved_form = this.clone_deep(this.form); //here saved_form is default form data
    },
    load_edit_page() {
      Object.assign(this.$data, this.$options.data.apply(this)); //re-initilize data in Vue
      this.view = "edit";
      this.service_id = this.$route.params.service_id;
      this.saved_form.service_admin_user_ids = [0]; //to avoid showing current admin profile picture till data loads

      let action = "edit_service";
      let wpcal_request = {};
      wpcal_request[action] = {
        service_id: this.service_id
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            dont_notify_success: true
          });
          if (
            response.data &&
            response.data[action].status == "error" &&
            (response.data[action].error == "access_denied" ||
              response.data[action].error == "service_no_longer_editable")
          ) {
            this.form = this.clone_deep(this.saved_form); //hack fix - to avoid on_before_leave_alert_if_unsaved alert
            this.$router.push("/event-types");
            return;
          }
          if (
            response.data &&
            response.data[action].hasOwnProperty("service_data")
          ) {
            this.form = response.data[action].service_data;
            this.saved_form = this.clone_deep(this.form);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async form_submit() {
      this.clear_validation_errors_cont();
      this.create_or_update_btn_is_enabled = false;
      let action;
      if (this.$route.name == "service_add") {
        action = "add_service";
      } else if (this.$route.name == "service_edit") {
        action = "update_service";
      }

      let form_data = this.clone_deep(this.form);
      if (
        form_data.hasOwnProperty("invitee_questions") &&
        form_data.invitee_questions.hasOwnProperty("questions") &&
        form_data.invitee_questions.questions.length === 0
      ) {
        form_data.invitee_questions["__questions_count"] = 0; //workaround to post this array if 'questions' is empty, currently that is only key
      }

      let wpcal_request = {};
      wpcal_request[action] = {
        service_id: this.service_id,
        service_data: form_data
      };

      let action_edit_service = "edit_service";
      if (this.$route.name == "service_edit") {
        wpcal_request[action_edit_service] = {
          service_id: this.service_id
        };
        this.log_service_name_last_saved();
      }

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      await axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          //alert(response.data[action].status);
          let success_msg = this.T__("Event type updated successfully.");
          if (action === "add_service") {
            success_msg = this.T__("Event type added successfully.");
          }

          this.notify_single_action_result(response.data[action], {
            success_msg: success_msg
          });
          if (this.$route.name == "service_add") {
            if (
              response.data &&
              response.data[action].status == "success" &&
              response.data[action].hasOwnProperty("service_id")
            ) {
              this.skip_leaving_warining = true;
              let service_id = response.data[action].service_id;
              this.$router.push("/event-type/edit/" + service_id);
            }
          }
          if (this.$route.name == "service_edit") {
            if (response.data && response.data[action].status === "success") {
              let current_submitted_step_id = this.edit_view.step2.form
                ? 2
                : this.edit_view.step3.form
                ? 3
                : "";
              if (current_submitted_step_id) {
                this.scroll_to_if_not_in_view_port(
                  "#service_form_step" + current_submitted_step_id
                );
              }
              this.edit_view_reset();
            }
          }

          if (
            response.data &&
            response.data.hasOwnProperty(action_edit_service) &&
            response.data[action_edit_service].hasOwnProperty("service_data")
          ) {
            this.form = response.data[action_edit_service].service_data;
            this.saved_form = this.clone_deep(this.form);
            this.may_alert_to_update_booking_page_on_service_name_change();
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.create_or_update_btn_is_enabled = true;
        });
    },
    log_service_name_last_saved() {
      if (this.view != "edit") {
        return;
      }
      this.service_name_last_saved = this.saved_form.name;
    },
    may_alert_to_update_booking_page_on_service_name_change() {
      if (this.view != "edit") {
        return;
      }
      if (this.service_name_last_saved != this.saved_form.name) {
        this.$modal.show("dialog", {
          title: this.T__("The event type name has been updated."),
          text: this.Tsprintf(
            /* translators: 1: html-tag-open 2: html-tag-close */
            this.T__(
              "Please note that this will not change the booking page title. If you want to change that, you can do so here - %1$sEdit Booking Page %2$s"
            ),
            '<a style="font-size:14px;" href="post.php?post=' +
              this.saved_form.post_id +
              '&action=edit" target="_blank">',
            '<span style="font-size:11px; font-weight:600; position: absolute; margin: 2px;">&nearr;</span></a>'
          ),
          buttons: [
            {
              title: this.T__("Okay"),
              default: true // Will be triggered by default if 'Enter' pressed.
            }
          ]
        });
      }
    }
  },
  created() {
    this.load_page();
    this.$store.dispatch("load_managed_active_admins_details");
  },
  mounted() {
    //console.log(this.$route);
    //this.set_active_step(3);
    this.toggle_steps();
  },
  watch: {
    //eslint-disable-next-line
    "$route.name": function() {
      //console.log(new_route_name, old_route_name);
      this.load_page();
    },
    document_title() {
      this.$store.dispatch("set_document_title", this.document_title);
    }
  }
};
</script>
